$( document ).ready(function() {
    if(!getCookie('age_verifier')) {
        document.getElementsByTagName('html')[0].style.overflowY = "hidden";
        document.getElementById("ageVerifier").classList.toggle("is-active");
    }
});

function verifyAge(){
    var date = new Date($("#date").combodate('getValue').replace(/-/g, "/"));
    const age = _calculateAge(date);
    if(age>=19){
        // Add 1 day for expiry
        var expires = new Date(new Date().getTime() + 60 * 60 * 24 * 1000);
        document.cookie = `age_verifier=true; expires=${expires}`;
        document.getElementsByTagName('html')[0].style.overflowY = "scroll";
        document.getElementById("ageVerifier").classList.toggle("is-active");
    }else{
        document.getElementById('ageVerifierBody').innerHTML = '<p>Sorry, you do not meet the age requirements to access this site.</p>'
    }
}

function _calculateAge(birthday) { // birthday is a date
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

function closeAgeVerifier() {
    document.getElementById("ageVerifier").classList.toggle("is-active");
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}